import React from 'react';

/**
 * Explains what the section does and how it maps to the kitchen-operation API.
 * Larger type than the old single-line banner (title 16px, body 14px).
 */
export function SectionInfoBanner({ title, children }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        background: '#FFF8F3',
        border: '2px solid #ff8e2cff',
        borderRadius: 8,
        padding: '16px 18px',
        marginBottom: 20,
        lineHeight: 1.55,
        fontfamily: 'Inter Regular',
        fontSize: 14,
        letterSpacing: '0.20px',
        // color: '#181436',
      }}
    >
      {/* <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          color: '#181436',
          letterSpacing: 0.15,
          lineHeight: 1.35,
        }}
      >
        {title}
      </div> */}
      <div
        style={{
          fontSize: 14,
          color: '#5c4a3a',
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}
      >
        {children}
      </div>
    </div>
  );
}
